import Card from "@/components/Card";
import React, { useEffect, useState } from "react";
import { Navigate, replace, useLocation, useParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UserRoundIcon } from "lucide-react";
import AdhocTab from "./tabs/adhoc/AdhocTab";
import { Payslip, ProcessingStatus } from "@/models/payslips.model";
import { getPayslip } from "@/api/payslips";
import BonusTab from "./tabs/bonus/BonusTab";
import DeductionTab from "./tabs/deduction/DeductionTab";
import { DeductionItem } from "@/models/deduction-items.model";
import OthersTab from "./tabs/others/OthersTab";
import SalaryInfoForm from "./SalaryInfoForm";

function PayItemsPage() {
  const location = useLocation();
  const { userId, year, month } = useParams();
  const processingStatus = location.state.processingStatus as ProcessingStatus;
  console.log("processing status", processingStatus);
  // const user = location.state.user as User;

  const [payslip, setPayslip] = useState<Payslip | undefined>();
  useEffect(() => {
    const fetchPayslip = async () => {
      // if (
      //   processingStatus === ProcessingStatus.ITEMS_ADDED ||
      //   processingStatus === ProcessingStatus.PROCESSED
      // ) {
      // fetch payslip
      try {
        const payslip = await getPayslip(
          Number(userId),
          Number(year),
          Number(month)
        );
        console.log("payslips", payslip);
        setPayslip(payslip);
      } catch (error) {
        console.log('No payslip found for user', userId, 'for month', month, 'year', year);
        // set salaryinfo to default to payment info of user
      }
    }
    // };
    fetchPayslip();
  }, [processingStatus, userId, year, month]);

  if (!userId || !year || !month)
    return <Navigate to="/admin/process-pay" replace />;

  return (
    <div className="flex flex-row h-[100vh] w-full p-5 gap-5">
      <Card styles="w-2/5 flex h-full">
        <SalaryInfoForm
          payslip={payslip}
          year={Number(year)}
          month={Number(month)}
          userId={Number(userId)}
        />
      </Card>
      <Card styles="w-3/5 flex flex-col p-4 gap-6">
        <div className="flex gap-10 w-full">
          <Tabs defaultValue="staff-info" className="w-full space-y-4">
            <TabsList className="w-full">
              <TabsTrigger value="staff-info" className="flex-1">
                Ahoc
              </TabsTrigger>
              <TabsTrigger value="employment-info" className="flex-1">
                Bonus
              </TabsTrigger>
              <TabsTrigger value="payment-info" className="flex-1">
                Deductions
              </TabsTrigger>
              <TabsTrigger value="leave-balance" className="flex-1">
                Others
              </TabsTrigger>
            </TabsList>

            <TabsContent value="staff-info" className="mt-4">
              <AdhocTab
                payslipId={payslip?.id}
                userId={Number(userId)}
                year={Number(year)}
                month={Number(month)}
              />
            </TabsContent>

            <TabsContent value="employment-info" className="mt-4">
              <BonusTab
                payslipId={payslip?.id}
                userId={Number(userId)}
                year={Number(year)}
                month={Number(month)}
              />
            </TabsContent>

            <TabsContent value="payment-info" className="mt-4">
              <DeductionTab
                payslipId={payslip?.id}
                userId={Number(userId)}
                year={Number(year)}
                month={Number(month)}
              />
            </TabsContent>
            <TabsContent value="leave-balance" className="mt-4">
              <OthersTab
                payslipId={payslip?.id}
                userId={Number(userId)}
                year={Number(year)}
                month={Number(month)}
              />
            </TabsContent>
          </Tabs>
        </div>
      </Card>
    </div>
  );
}

export default PayItemsPage;
